import { Box } from "@mui/material";
import { useCallback, useContext } from "react";
import { useLocation } from "react-router-dom";
import { routes } from "../../constants/routes";
import { ContentfulContext } from "../../context/ContentfulContext";
import { Header as HeaderModel, Maybe } from "../../models/schema";
import { colors } from "../../theme/colors";
import { InternalLink } from "./InternalLink";

const NavigationPanel = ({
  mobile,
  variant = "header",
  setMobileNavOpen
}: {
  mobile?: boolean;
  variant?: "header" | "footer";
  setMobileNavOpen?: () => void;
}) => {
  const location = useLocation();

  const { content } = useContext(ContentfulContext);
  const { projects, references, aboutUs, contact } = content?.header as HeaderModel;

  const navigationOptions: { route: string; label?: Maybe<string> }[] = [
    { route: routes.solutions, label: projects },
    { route: routes.references, label: references },
    { route: routes.aboutUs, label: aboutUs },
    { route: routes.contact, label: contact }
  ];

  const getLinkColor = useCallback(
    (route: string) => {
      const active = location.pathname === route;

      const mobileColors = {
        active: colors.darkYellow,
        inactive: variant === "header" ? colors.black : colors.white
      };

      const desktopColors = {
        active: colors.yellow,
        inactive: colors.white
      };

      if (mobile) {
        return active ? mobileColors.active : mobileColors.inactive;
      } else {
        return active ? desktopColors.active : desktopColors.inactive;
      }
    },
    [location.pathname, mobile, variant]
  );

  return (
    <Box
      sx={{
        display: "flex",
        width: variant === "header" ? "100%" : "auto",
        flexDirection: mobile ? "column" : "row",
        "& > :not(template) ~ :not(template)": {
          mt: mobile ? 2 : 0,
          ml: mobile ? 0 : 2
        }
      }}>
      {navigationOptions.map((option) => (
        <InternalLink
          key={option.label}
          onClick={setMobileNavOpen}
          to={option.route}
          sx={{
            width: "100%",
            color: getLinkColor(option.route),
            textDecoration: "none"
          }}>
          {option.label as string}
        </InternalLink>
      ))}
    </Box>
  );
};

export default NavigationPanel;
